import { render, staticRenderFns } from "./Query.vue?vue&type=template&id=68b9ab0d&"
import script from "./Query.vue?vue&type=script&lang=ts&"
export * from "./Query.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports